import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Permission } from '../../core/models/permission.type';
import { PushNotification } from '../../core/models/push-notification.model';

@Injectable({ providedIn: 'root' })
export class BrowserNotificationsService {
    permission: Permission;

    constructor() {
        this.permission = this.isSupported() ? 'default' : 'denied';
    }

    isSupported(): boolean {
        return 'Notification' in window;
    }

    requestPermission(): Observable<Permission> {
        if ('Notification' in window) {
            Notification.requestPermission((status) => {
                this.permission = status;
                return new Observable((obs) => {
                    return obs.next(this.permission);
                });
            });
        }
        return new Observable((obs) => {
            return obs.next('denied');
        });
    }

    create(title: string, options?: PushNotification): Observable<any> {
        return new Observable((obs) => {
            const notify = new Notification(title, options);
            notify.onshow = (e) => {
                return obs.next({
                    notification: notify,
                    event: e,
                });
            };
            notify.onclick = (e) => {
                setTimeout(() => {
                    notify.close();
                }, 50);

                return obs.next({
                    notification: notify,
                    event: e,
                });
            };
            notify.onerror = (e) => {
                return obs.error({
                    notification: notify,
                    event: e,
                });
            };
            notify.onclose = () => {
                return obs.complete();
            };
        });
    }

    generateNotification(item: { alertContent: string; title: string }): Observable<any> {
        const options = {
            body: item.alertContent,
            icon: '../assets/images/chat-icon.png',
        };

        return this.create(item.title, options);
    }
}
